import React from 'react';
import { Card, CardBody, CardTitle, Table, Spinner } from 'reactstrap';

import FeatherIcon from 'feather-icons-react';
import moment from 'moment';
//Simple bar
import SimpleBar from 'simplebar-react';

//Import Image
import avatar4 from '../../../../assets/images/avatar_male.png';

const PunishmentListComponent = ({
  options = [],
  height = '490px',
  loading = true,
}) => {
  const dateParse = (input) => {
    let res = '-';
    if (input != '' && input != null) {
      res = moment(input).format('DD/MM/YYYY');
    }
    return res;
  };

  return (
    <React.Fragment>
      <Card
        style={{
          height: height,
          borderRadius: '20px',
          boxShadow:
            '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
        }}
        className="overflow-auto"
      >
        <CardBody>
          <CardTitle>Daftar Pegawai Terkena Hukuman Disiplin</CardTitle>
          <SimpleBar>
            {loading == false ? (
              <div className="table-responsive">
                <Table className="table-borderless table-centered">
                  <tbody>
                    {options.length > 0 ? (
                      options.map((data, index) => {
                        return (
                          <tr key={`tr-${index}`}>
                            <td style={{ width: '20px' }}>
                              <img
                                src={avatar4}
                                className="avatar-xs rounded-circle "
                                alt="..."
                              />
                            </td>
                            <td>
                              <h6 className="font-size-15 mb-1 fw-normal">
                                {data.nama}
                              </h6>
                              <p className="font-size-10 mb-0">
                                <span className="text-danger">
                                  <i className="mdi mdi-format-list-bulleted-type"></i>{' '}
                                  Hukuman :{' '}
                                </span>{' '}
                                {data.jenishukuman}
                              </p>
                            </td>
                            <td className="text-muted fw-semibold text-end"></td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={2} className="text-center">
                          Tidak Ada Data Pegawai Terkena Hukuman Disiplin
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div className="text-center" style={{ marginTop: '180px' }}>
                <Spinner className="m-2" color="primary" />
              </div>
            )}
          </SimpleBar>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default PunishmentListComponent;
